import { CircularProgress } from '@ixigo/iui/CircularProgress';

export function PageLoader() {
	return (
		<output className="flex justify-center py-16">
			<CircularProgress value={30} size={36} thickness={3} spin />
			<span className="sr-only">Loading</span>
		</output>
	);
}
